import type { ChipToken, Theme } from 'hephaestus/core';
import { merge } from 'lodash-es';

export const useChipTokens = (theme: Theme): ChipToken => {
  const { color, component } = theme;
  const base = {
    borderColor: color.outline,
    textColor: color.onSurface,
    labelColor: color.onSurfaceVariant,
    hoverColor: color.primaryVariantHover,
    hoverBorderColor: color.primary,
  };

  return merge({}, base, component?.chip) as ChipToken;
};
